<!-- Properties Button with Material Menu -->
    <button 
      mat-raised-button
      [matMenuTriggerFor]="propertiesMenu"
      [disabled]="!showPropertiesButton"
      class="properties-menu-button">
      
      <!-- Dynamic preview based on active tool -->
      <div class="button-content">
        <div  *ngIf="isDrawingTool || !isFontTool">
          <svg class="line-preview">
            <line 
              x1="0" y1="10" 
              x2="50" y2="10" 
              [attr.stroke]="showPropertiesButton ? '#333' : '#999'"
              [attr.stroke-width]="properties.strokeWidth"
              [attr.stroke-dasharray]="getStrokeDashArray(properties.lineStyle)"
            />
          </svg>
          <span class="value" [style.color]="showPropertiesButton ? '#666' : '#999'">{{ properties.strokeWidth }}px</span>
        </div>
      
        <div *ngIf="isFontTool && !isDrawingTool">
          <span class="font-preview">{{ getFontDisplay(properties.fontFamily) }}</span>
          <span class="font-preview">{{ properties.fontSize }}px</span>
        </div>
        
        <span class="material-symbols-outlined dropdown-icon">arrow_drop_down</span>
      </div>

    </button>

    <!-- Material Menu -->
    <mat-menu #propertiesMenu="matMenu" class="properties-menu">
      <div class="menu-content" (click)="$event.stopPropagation()">
        
        <!-- Line Width -->
        <mat-form-field subscriptSizing="dynamic">
          <div class="inline-menu">
          <mat-select [disabled]="!isDrawingTool"
            [(value)]="properties.strokeWidth"
            (selectionChange)="onPropertyChange()"
            panelClass="line-width-panel">
            <mat-select-trigger>
              <div class="select-trigger">
                <svg width="50" height="16" viewBox="0 0 50 16" class="inline-preview">
                  <line 
                    x1="2" y1="8" 
                    x2="48" y2="8" 
                    [attr.stroke]="isDrawingTool ? '#333' : '#ccc'"
                    [attr.stroke-width]="properties.strokeWidth"
                    stroke-linecap="round"
                  />
                </svg>
                <span>{{ properties.strokeWidth }}px</span>
              </div>
            </mat-select-trigger>
            <mat-option *ngFor="let option of lineWidthOptions" [value]="option.value">
              <div class="option-content">
                <svg width="80" height="20" viewBox="0 0 80 20">
                  <line 
                    x1="5" y1="10" 
                    x2="75" y2="10" 
                    stroke="#333"
                    [attr.stroke-width]="option.value"
                    stroke-linecap="round"
                  />
                </svg>
                <span class="option-label">{{ option.label }}</span>
              </div>
            </mat-option>
          </mat-select>
          <span>{{'Whiteboard.property.width' | translate}}</span>

          </div>
        </mat-form-field>

        <!-- Line Style -->
        <mat-form-field subscriptSizing="dynamic">
          <div class="inline-menu">
          <mat-select [disabled]="!isDrawingTool"
            [(value)]="properties.lineStyle"
            (selectionChange)="onPropertyChange()">
            <mat-select-trigger>
              <div class="select-trigger">
                <svg width="50" height="16" viewBox="0 0 50 16" class="inline-preview">
                  <line 
                    x1="2" y1="8" 
                    x2="48" y2="8" 
                    [attr.stroke]="isDrawingTool ? '#333' : '#ccc'"
                    stroke-width="2"
                    [attr.stroke-dasharray]="getStrokeDashArray(properties.lineStyle)"
                    stroke-linecap="round"
                  />
                </svg>

              </div>
            </mat-select-trigger>
            <mat-option *ngFor="let option of lineStyleOptions" [value]="option.value">
              <div class="option-content">
                <svg width="80" height="20" viewBox="0 0 80 20">
                  <line 
                    x1="5" y1="10" 
                    x2="75" y2="10" 
                    stroke="#333"
                    stroke-width="2"
                    [attr.stroke-dasharray]="getStrokeDashArray(option.value)"
                    stroke-linecap="round"
                  />
                </svg>
                <span class="option-label">{{ option.label }}</span>
              </div>
            </mat-option>
          </mat-select>
          <span>{{'Whiteboard.property.style' | translate }}</span>
          </div>
        </mat-form-field>

        <!-- Font Family -->
        <mat-form-field subscriptSizing="dynamic">
          <div class="inline-menu">
          <mat-select  [disabled]="!isFontTool"
            [(value)]="properties.fontFamily"
            (selectionChange)="onPropertyChange()">
            <mat-option *ngFor="let option of fontOptions" [value]="option.value">
              <span [style.font-family]="option.value">{{ option.label }}</span>
            </mat-option>
          </mat-select>
          <span>{{'Whiteboard.property.font'|translate}}</span>
          </div>
        </mat-form-field>

        <!-- Font Size -->
        <mat-form-field subscriptSizing="dynamic">
          <div class="inline-menu">
          <mat-select [disabled]="!isFontTool"
            [(value)]="properties.fontSize"
            (selectionChange)="onPropertyChange()">
            <mat-option *ngFor="let size of fontSizeOptions" [value]="size">
              {{ size }}px
            </mat-option>
          </mat-select>
          <span>{{'Whiteboard.property.fontsize' | translate}}</span>
          </div>
        </mat-form-field>
        <div class="inline-menu">
          <div class="text-style-buttons">
            <button mat-button
                    [disabled]="!isFontTool"
                    [class.active]="isBold"
                    (click)="toggleBold()">
              <b>B</b>
            </button>
            <button mat-button
                    [disabled]="!isFontTool"
                    [class.active]="isItalic"
                    (click)="toggleItalic()">
              <i>I</i>
            </button>
          </div>
          <span class="text-style-label">{{'Whiteboard.property.fontstyle' | translate}}</span>
        </div>
      </div>
    </mat-menu>